<div class="app-wrapper" *ngIf="access">
  <nav class="tab_navigation">
      &nbsp;
  </nav>
  <section class="main-content settings-section">
      <div class="app-main m_licenses">
          <header>
              <div class="data-header">
                  <core-title-section
                    [title]="'Manage users'"
                    [breadcrumbs]="breadcrumbs"
                  ></core-title-section>
                  <div class="button-settings-add">
                    <core-helpers-navigation-three-dots-menu
                      [menu]="menu"
                      (action)="onMenuClick($event)"
                    ></core-helpers-navigation-three-dots-menu>
                  </div>
              </div>
          </header>
          <div class="users-section">
            <div class="loader" *ngIf="loadingSeats">
              <div class="dimmed">
                <div class="dimmed_table_box">
                  <header>
                    <div class="dimmed_flex">
                      <div class="dimmed_title"></div><span class="sep">-</span>
                      <div class="dimmed_title"></div>
                    </div>
                  </header>
                  <div class="dimmed_flex">
                    <div class="dimmed_flex_section">
                      <div class="dimmed_avatar"></div>
                      <div class="dimmed_info">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_subtitle"></div>
                        <div class="dimmed_subtitle"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dimmed_flex">
                    <div class="dimmed_flex_section">
                      <div class="dimmed_avatar"></div>
                      <div class="dimmed_info">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_subtitle"></div>
                        <div class="dimmed_subtitle"></div>
                      </div>
                    </div>
                  </div>
                  <div class="dimmed_flex">
                    <div class="dimmed_flex_section">
                      <div class="dimmed_avatar"></div>
                      <div class="dimmed_info">
                        <div class="dimmed_title"></div>
                        <div class="dimmed_subtitle"></div>
                        <div class="dimmed_subtitle"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- mar 2023: we manage seats now -->
            <settings-users-list-users *ngIf="!loadingSeats" (reload)="tryAgain($event)"></settings-users-list-users>
          </div>
      </div>
  </section>
</div>


<core-helpers-box-http-error *ngIf="!access" [code]="''"[message]="'Not Access'"></core-helpers-box-http-error>
